import { datadogRum } from "@datadog/browser-rum";

export const ddRum = datadogRum;
